import React, { useState, useEffect } from "react";
import GICS from "gics";
import CustomReactSelect from "../../../../general/form/CustomReactSelect"; // Adjust path to your CustomReactSelect component

// Function to build the full four-level GICS hierarchy
const buildGicsHierarchy = () => {
  const sectorCodes = ["10", "15", "20", "25", "30", "35", "40", "45", "50", "55", "60"];
  
  // Flattened structure
  const flattenedOptions = [];

  sectorCodes.forEach((sectorCode) => {
    const sector = new GICS(sectorCode);
    sector.children.forEach((group) => {
      const industryGroup = new GICS(group.code);
      industryGroup.children.forEach((industry) => {
        const industryInstance = new GICS(industry.code);
        industryInstance.children.forEach((subIndustry) => {
          flattenedOptions.push({
            label: subIndustry.name,
            value: subIndustry.code,
            groupLabel: `${sector.sector.name} > ${industryGroup.industryGroup.name} > ${industryInstance.industry.name}`,
          });
        });
      });
    });
  });

  // Group by `groupLabel`
  const groupedOptions = flattenedOptions.reduce((acc, option) => {
    const group = acc.find((g) => g.label === option.groupLabel);
    if (group) {
      group.options.push({ label: option.label, value: option.value });
    } else {
      acc.push({
        label: option.groupLabel,
        options: [{ label: option.label, value: option.value }],
      });
    }
    return acc;
  }, []);

  return groupedOptions;
};


console.log("buildGicsHierarchy:", buildGicsHierarchy());
const GicsSelect = ({ onChange }) => {
  const [gicsOptions, setGicsOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    try {
      // Build GICS hierarchy on component mount
      const formattedOptions = buildGicsHierarchy();
      setGicsOptions(formattedOptions);
      console.log("Formatted GICS Options:", formattedOptions); // Log formatted options for inspection
    } catch (error) {
      console.error("Error building GICS hierarchy:", error);
    }
  }, []);

  const handleSelectChange = (newSelectedOptions) => {
    console.log("Selected Options:", newSelectedOptions); // Log selected options to debug

    // Update selected options directly
    setSelectedOptions(newSelectedOptions);

    // Extract values for parent onChange
    const selectedValues = newSelectedOptions ? newSelectedOptions.map((option) => option.value) : [];
    onChange(selectedValues);
  };

  return (
    <CustomReactSelect
      options={gicsOptions}
      onChange={handleSelectChange}
      isMulti
      value={selectedOptions} // Track selected values to match options
      placeholder="Select GICS classification"
      isSearchable
      noOptionsMessage={() => "No GICS options available"}
    />
  );
};

export default GicsSelect;
